import { render } from "./App.vue?vue&type=template&id=3d092ce9"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3d092ce9&lang=css"
script.render = render

export default script